module.exports = __webpack_public_path__ + "static/media/inetvideo.72ad1a27.png";